export class NativeStreamChoiceOption {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "value",
            "baseName": "value",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamChoiceOption.attributeTypeMap;
    }
    constructor() {
    }
}
